// import { CircularProgress, Dialog } from "@mui/material";
import React, { useRef, useState,useEffect } from 'react';
const getCookie = require('../utils/getCookie')



function UploadComponent({ fkAtividade }) {
  const fileInputRef = useRef(null);
  const [uploadResult, setUploadResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false)

  const handleUpload = () => {
    const file = fileInputRef.current.files[0];

    if (!file) {
      setErrorMessage('Por favor, selecione um arquivo.');
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("keyapi", "99bd4c69-322d-424d-8b9c-4622fdd997ab");

    const formData = new FormData();
    formData.append("arquivo", file, file.name);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow"
    };
   

    fetch("https://www7.pe.senac.br/storage/api/arquivo", requestOptions)
      .then(response => {
        console.log('Status da resposta:', response.status);
        console.log('Cabeçalhos da resposta:', Array.from(response.headers.entries()));

        // Verificar se a resposta foi bem-sucedida
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return response.text(); // Lê a resposta como texto
      })
      .then(result => {
        console.log('Resposta recebida:', result); // Mostra a resposta bruta

        try {
          const parsedResult = JSON.parse(result);
          console.log('Resposta parseada:', parsedResult); // Mostra a resposta parseada
          setUploadResult(parsedResult);
          setErrorMessage('');
      
        } catch (e) {
          console.error('Erro ao parsear a resposta:', e);
          setErrorMessage('Ocorreu um erro ao salvar o arquivo.');
        }
      })
      .catch(error => {
        console.error('Erro ao fazer o fetch:', error);
        setUploadResult(null);
        setErrorMessage('Ocorreu um erro ao salvar o arquivo.');
      }).finally(() => {
        window.location.reload();
    })
  };

  useEffect(() => {


    if (uploadResult) {
      salvarArquivo()

    }
  }, [uploadResult])

 


  const salvarArquivo = () => {
    // alert(newStatus)


    const token = getCookie('_token_task_manager')
    const params = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        fkAtividade, 
        nomeArquivo: uploadResult.data.nome,
        hash: uploadResult.data.hash

      })

    }

    fetch(`${process.env.REACT_APP_DOMAIN_API}/api/arquivo/api`, params)
      .then(response => {
        const { status } = response
        response.json().then(data => {
          setOpenLoadingDialog(false)
          if (status === 401) {
            alert(2)
            // setOpenMessageDialog(true)
          } else if (status === 200) {
            alert(data.message)

          }
        }).catch(err => setOpenLoadingDialog(true))
      })
  }

  return (
    <div>


      <div>
        <h2>Selecione o arquivo e clique em enviar</h2>
        <input
        type="file"
        ref={fileInputRef}
        style={{
          padding: '10px',
          borderRadius: '5px',
          border: '1px solid #ccc',
          marginBottom: '20px',
          width: '100%',
          fontSize: '16px'
        }}
      />
      <button
        onClick={handleUpload}
        style={{
          backgroundColor: '#108cdd',
          color: 'white',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          transition: 'red'
        }}
        onMouseEnter={e => e.target.style.backgroundColor = 'red'}
        onMouseLeave={e => e.target.style.backgroundColor = '#108cdd'}
      >
        Enviar
      </button>

        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
        {uploadResult && (
          <div style={{ marginTop: '20px', padding: '10px', border: '1px solid green' }}>
            {uploadResult.message === "Cadastro realizado com sucesso." ? (
              <div>
                <p><strong>Sucesso:</strong> {uploadResult.message}</p>
                <p><strong>Nome do Arquivo:</strong> {uploadResult.data.nome}</p>
                <p><strong>Tamanho:</strong> {uploadResult.data.tamanho}</p>
                <p><strong>Hash:</strong> {uploadResult.data.hash}</p>
                
              </div>
            ) : (
              <p><strong>Erro:</strong> {uploadResult.message}</p>
            )}
          </div>
        )}
      </div>

      {/* <Dialog open={openLoadingDialog}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: 120, height: 120 }}>
          <CircularProgress />
        </div>
      </Dialog> */}
    </div>


  );
}

export default UploadComponent;
